'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidMail = function IoAndroidMail(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm31.6 6.3c1.8 0 3.4 1.5 3.4 3.3v20.8c0 1.8-1.6 3.4-3.4 3.4h-28.2c-1.8 0-3.4-1.6-3.4-3.4v-20.8c0-1.8 1.6-3.3 3.4-3.3h28.2z m-0.3 7.1v-3.4l-13.8 9.1-13.7-9.1v3.4l13.7 9.1z' })
        )
    );
};

exports.default = IoAndroidMail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-mail.js
// module id = 1875
// module chunks = 0